import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from './user/user.service';

@Injectable({
  providedIn: 'root'
})
export class LoginRouteGuard implements CanActivate {

  constructor(private userService: UserService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.userService.hasUserInfo) {
      return this.handleUserInfo(route, state);
    } else if (route.queryParams.token) {
      this.userService.setToken(route.queryParams.token);
      return true;
    } else if(this.userService.userInfoObservable) {
      return this.userService.userInfoObservable.map((data) => {
        return this.handleUserInfo(route, state);
      });
    } else {
      return this.handleUserInfo(route, state);
    }
  }

  private handleUserInfo(route, state) {
    if (this.userService.isAllowed()) {
        return true;
    } else {
      this.router.navigate(['/login'], {
        queryParams: {
          return: state.url
        }
      });
      return false;
    }
  }
}
